import { createRouter, createWebHistory } from "vue-router";
import { defaultTitle } from "../assets/scripts/config";
import List from "../views/UnitList.vue";
import UnitTitlesJson from "@/assets/json/unit_titles.json";
import LearningUnit01 from "../assets/json/learning_unit_01.json";
import LearningUnit02 from "../assets/json/learning_unit_02.json";
import LearningUnit03 from "../assets/json/learning_unit_03.json";
import LearningUnit04 from "../assets/json/learning_unit_04.json";
import LearningUnit05 from "../assets/json/learning_unit_05.json";
import LearningUnit06 from "../assets/json/learning_unit_06.json";
import LearningUnit07 from "../assets/json/learning_unit_07.json";
import LearningUnit08 from "../assets/json/learning_unit_08.json";
import LearningUnit09 from "../assets/json/learning_unit_09.json";
import LearningUnit10 from "../assets/json/learning_unit_10.json";
import LearningUnit11 from "../assets/json/learning_unit_11.json";
import store from "@/store/index.js";

const { unit_titles } = UnitTitlesJson;

const getUnitTitle = (unitTitles) => {
  const sideMenuTitle = unitTitles.side_menu_title;
  console.log(sideMenuTitle);
  const hasSideMenuTitle = !(
    sideMenuTitle === undefined || sideMenuTitle === ""
  );
  console.log(hasSideMenuTitle);
  return hasSideMenuTitle ? unitTitles.side_menu_title : unitTitles.title;
};

const routes = [
  {
    path: "/",
    name: "List",
    component: List,
    meta: { title: "BRIGHTEST English Communication Ⅱホーム" },
    props: {
      unitTitlesJson: UnitTitlesJson,
    },
  },
  {
    path: "/a/",
    name: "a",
    component: () =>
      import(/* webpackChunkName: "A" */ "../views/LearningUnit.vue"),
    meta: { title: "Lesson 1" },
    props: {
      unitTitle: getUnitTitle(unit_titles[0]),
      learningUnitJson: LearningUnit01,
    },
  },
  {
    path: "/b/",
    name: "b",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Lesson 2" },
    props: {
      unitTitle: getUnitTitle(unit_titles[1]),
      learningUnitJson: LearningUnit02,
    },
  },
  {
    path: "/c/",
    name: "c",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Lesson 3" },
    props: {
      unitTitle: getUnitTitle(unit_titles[2]),
      learningUnitJson: LearningUnit03,
    },
  },
  {
    path: "/d/",
    name: "d",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Lesson 4" },
    props: {
      unitTitle: getUnitTitle(unit_titles[3]),
      learningUnitJson: LearningUnit04,
    },
  },
  {
    path: "/e/",
    name: "e",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Lesson 5" },
    props: {
      unitTitle: getUnitTitle(unit_titles[4]),
      learningUnitJson: LearningUnit05,
    },
  },
  {
    path: "/f/",
    name: "f",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Lesson 6" },
    props: {
      unitTitle: getUnitTitle(unit_titles[5]),
      learningUnitJson: LearningUnit06,
    },
  },
  {
    path: "/g/",
    name: "g",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Lesson 7" },
    props: {
      unitTitle: getUnitTitle(unit_titles[6]),
      learningUnitJson: LearningUnit07,
    },
  },
  {
    path: "/h/",
    name: "h",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Lesson 8" },
    props: {
      unitTitle: getUnitTitle(unit_titles[7]),
      learningUnitJson: LearningUnit08,
    },
  },
  {
    path: "/i/",
    name: "i",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Lesson 9" },
    props: {
      unitTitle: getUnitTitle(unit_titles[8]),
      learningUnitJson: LearningUnit09,
    },
  },
  {
    path: "/j/",
    name: "j",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Lesson 10" },
    props: {
      unitTitle: getUnitTitle(unit_titles[9]),
      learningUnitJson: LearningUnit10,
    },
  },
  {
    path: "/k/",
    name: "k",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Reading" },
    props: {
      unitTitle: getUnitTitle(unit_titles[10]),
      learningUnitJson: LearningUnit11,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach((to) => {
  document.title = to.meta.title || defaultTitle;
});

router.beforeEach(() =>{
  store.commit(
    "toggleDarkMode",
    localStorage.getItem("darkModeFrag") === "true"
  );
});

export default router;
